import { render, staticRenderFns } from "./InputColorPicker.vue?vue&type=template&id=2d87e960&scoped=true"
import script from "./InputColorPicker.vue?vue&type=script&lang=js"
export * from "./InputColorPicker.vue?vue&type=script&lang=js"
import style0 from "./InputColorPicker.vue?vue&type=style&index=0&id=2d87e960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d87e960",
  null
  
)

export default component.exports